import axios from "axios";
import httpAdapter from "axios/lib/adapters/http";
import settings from "~/settings";
import _ from "lodash";
import {
  FINGERPRINT_HEADER,
  getFingerprintId,
} from "~/utils/fingerprint";

const isServer = typeof window === "undefined";

// axiosInstance 是模块级单例，在服务端会被所有并发请求共享。
// 用 AsyncLocalStorage 按请求隔离 fingerprint，避免并发 SSR 时相互串号。
// 客户端不需要（每个用户独占实例），直接从 cookie 读取即可。
let fingerprintStore = null;
if (isServer) {
  // 用 __non_webpack_require__ 走 Node 运行时的原生 require，
  // 避免 webpack 把 node 内置模块 async_hooks 打进客户端 bundle。
  // eslint-disable-next-line no-undef
  const { AsyncLocalStorage } = __non_webpack_require__("async_hooks");
  fingerprintStore = new AsyncLocalStorage();
}

const axiosInstance = axios.create({
  baseURL: `${settings.apiUrl}/api/v1`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const fingerprintId = isServer
    ? fingerprintStore?.getStore()?.fingerprintId
    : getFingerprintId();
  if (fingerprintId) {
    config.headers[FINGERPRINT_HEADER] = fingerprintId;
  }
  return config;
});

export function withFingerprintHeader(fingerprintId, fn) {
  if (!fingerprintId || !fingerprintStore) {
    return fn();
  }

  return fingerprintStore.run({ fingerprintId }, fn);
}

axiosInstance.interceptors.response.use(
  (resp) => {
    return resp;
  },
  (err) => {
    if (err.response) {
      err.statusCode = err.response.status;
      const { data } = err.response;
      if (data && data.message) {
        err.data = data;
        err.message = data.message;
        err.error = data.error;
      }
    }

    return Promise.reject(err);
  }
);

export function request(options = {}) {
  return axiosInstance(options);
}

export function authRequest(token, options = {}) {
  const headers = _.assign({}, options.headers);
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return axiosInstance({
    ...options,
    headers: headers,
  });
}
